import "../styles/blocks/general/company-logos.scss";

import React from "react";
import PropTypes from "prop-types";
import {GatsbyImage as Image, getImage} from "gatsby-plugin-image";

const CompanyLogos = ({logos}) => {
    return (
        <div className="company-logos">
            {logos.map(({logo}, index) => {
                const {
                    altText,
                    localFile
                } = logo;

                const image = getImage(localFile);

                if (!image) {
                    return null;
                }

                return (
                    <div className="company-logos__logo" key={index}>
                        <div className="company-logos__logo-wrapper">
                            <div className="company-logos__logo-image-wrapper">
                                <Image
                                    image={image}
                                    className="company-logos__logo-image"
                                    alt={altText || "company-logos-image"}
                                    title={altText || "company-logos-image"}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

CompanyLogos.propTypes = {
    logos: PropTypes.array.isRequired
};

export default CompanyLogos;